import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { search, updateEnterpriseFilter } from '../../../../state/actions';
import { StateType } from '../../../../../state/reducers';

const mapState = ({ queryParams }: AnyAction) => ({
  originalQueryKey: queryParams.originalQueryKey,
  isFilterToggled: !!queryParams.eid,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  toggleLawyerFilter(enterpriseId: string | undefined) {
    dispatch(updateEnterpriseFilter(enterpriseId));
    dispatch(search({ reason: 'enterpriseFilter' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
